module.exports = __webpack_public_path__ + "static/media/ask.90da8e02.svg";